export class ConnectSourceAwsOrganizationalUnitRequest {
    'roleArn';
    'providerOrganizationalUnitId';
    'selectedAccountIds';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "roleArn",
            "baseName": "roleArn",
            "type": "string",
            "format": ""
        },
        {
            "name": "providerOrganizationalUnitId",
            "baseName": "providerOrganizationalUnitId",
            "type": "string",
            "format": ""
        },
        {
            "name": "selectedAccountIds",
            "baseName": "selectedAccountIds",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ConnectSourceAwsOrganizationalUnitRequest.attributeTypeMap;
    }
    constructor() {
    }
}
